export default __webpack_public_path__ + "static/media/Tata.43595410.png";